import { Checkbox } from '@headlessui/react';

import CheckIcon from '~/shared/assets/icons/check.svg';
import Typography from '~/shared/components/Typography';

const eligibilityOptions: Array<{ id: string; label: string }> = [
  { id: 'as_eligibility_supported', label: 'Supported' },
  { id: 'as_eligibility_potential', label: 'Pending Setup' },
  { id: 'as_eligibility_unsupported', label: 'Unsupported' },
];

export default function AutoscalingEligibilityFilter({
  pendingEligibility,
  setPendingEligibility,
}: {
  pendingEligibility: string[];
  setPendingEligibility: (states: string[]) => void;
}) {
  const handleEligibilityChange = (optionId: string) => {
    if (pendingEligibility.includes(optionId)) {
      setPendingEligibility(pendingEligibility.filter((s) => s !== optionId));
    } else {
      setPendingEligibility([...pendingEligibility, optionId]);
    }
  };

  return (
    <div className="px-8 py-3 border-b border-gray-300">
      <Typography fontWeight={600} variant="p2-semi" color="font-family-outfit text-primary-900 ">
        Autoscaling Eligibility
      </Typography>
      <div className="flex gap-6 mt-3 py-2.5 ">
        {eligibilityOptions.map((option) => {
          const id = `autoscale-eligibility-option-${option.id}`;
          return (
            <div key={option.id} className="flex items-center gap-2">
              <Checkbox
                id={id}
                checked={pendingEligibility.includes(option.id)}
                onChange={() => handleEligibilityChange(option.id)}
                className="group block size-5 p-[4px] rounded border border-primary-100 bg-white data-checked:bg-primary-500 ring:0 active:ring-primary-300 focus:ring-primary-500 cursor-pointer"
              >
                <CheckIcon className="text-white stroke-2 size-2.5 opacity-0 group-data-checked:opacity-100 transition duration-200 ease-in-out" />
              </Checkbox>
              <label
                htmlFor={id}
                className="cursor-pointer"
                onClick={() => handleEligibilityChange(option.id)}
              >
                <Typography variant="p2-semi">{option.label}</Typography>
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
}
